export const hospitalQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "A doctor is studying a medical scan.",
      B: "A doctor is writing a diagnosis report.",
      C: "A doctor is adjusting a hospital bed.",
      D: "A doctor is preparing an injection.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 의사가 의료 스캔 영상을 연구하고 있음\n" +
      "오답 설명: (B) 진단 보고서를 작성하지 않음, (C) 병원 침대를 조정하지 않음, (D) 주사를 준비하지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A doctor is writing a prescription.",
      B: "A doctor is using a stethoscope.",
      C: "A doctor is examining a radiology study.",
      D: "A doctor is talking to a nurse.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 의사가 방사선 검사 결과를 검토하고 있음\n" +
      "오답 설명: (A) 처방전을 작성하지 않음, (B) 청진기를 사용하지 않음, (D) 간호사와 대화하지 않음",
  },

  {
    questionNumber: 3,
    choices: {
      A: "A doctor is using a stethoscope.",
      B: "A doctor is using a medical instrument.",
      C: "A doctor is checking a patient's vision.",
      D: "A doctor is writing a prescription.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 의사가 의료 기구를 사용하고 있음\n" +
      "오답 설명: (A) 청진기를 사용하지 않음, (C) 시력을 검사하지 않음, (D) 처방전을 작성하지 않음",
  },

  {
    questionNumber: 4,
    choices: {
      A: "A patient is reading an eye chart.",
      B: "A medical professional is writing a prescription.",
      C: "A medical professional is using a stethoscope.",
      D: "A medical professional is conducting an eye exam.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 의료진이 시력 검사를 진행하고 있음\n" +
      "오답 설명: (A) 시력 차트를 읽지 않음, (B) 처방전을 작성하지 않음, (C) 청진기를 사용하지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "A medical professional is taking a patient's blood pressure.",
      B: "A medical professional is reviewing a medical chart.",
      C: "A medical professional is using a stethoscope.",
      D: "A medical professional is preparing an injection.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 의료진이 청진기를 사용하고 있음\n" +
      "오답 설명: (A) 혈압을 측정하지 않음, (B) 차트를 검토하지 않음, (D) 주사를 준비하지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A dentist is wearing protective equipment.",
      B: "A dentist is adjusting a patient's mask.",
      C: "A dentist is holding a medical chart.",
      D: "A dentist is talking on the phone.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 치과의사가 보호 장비를 착용하고 있음\n" +
      "오답 설명: (B) 환자의 마스크를 조정하지 않음, (C) 의료 차트를 들고 있지 않음, (D) 전화 통화를 하지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "A patient is walking down the hallway.",
      B: "A medical worker is pushing a wheelchair.",
      C: "A doctor is checking a patient's pulse.",
      D: "A patient is lying in a hospital bed.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 의료진이 휠체어를 밀고 있음\n" +
      "오답 설명: (A) 환자가 걷지 않음, (C) 맥박을 확인하지 않음, (D) 병상에 누워있지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A scientist is writing a report.",
      B: "A scientist is pouring a liquid into a beaker.",
      C: "A scientist is looking through a microscope.",
      D: "A scientist is adjusting a lab coat.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 과학자가 현미경으로 관찰하고 있음\n" +
      "오답 설명: (A) 보고서를 작성하지 않음, (B) 액체를 붓지 않음, (D) 실험복을 조정하지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A scientist is pouring liquid into a test tube.",
      B: "A scientist is looking through a microscope.",
      C: "A scientist is wearing protective gear.",
      D: "A scientist is writing down results.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 과학자가 보호 장비를 착용하고 있음\n" +
      "오답 설명: (A) 시험관에 액체를 붓지 않음, (B) 현미경을 사용하지 않음, (D) 결과를 기록하지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "One of the medical professionals is holding a clipboard.",
      B: "The two professionals are sitting on a bench.",
      C: "The medical professionals are ascending the stairs.",
      D: "They are stepping into an elevator.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 의료진들이 계단을 올라가고 있음\n" +
      "오답 설명: (A) 클립보드가 아닌 서류로 보이는 종이를 들고 있음 (B) 벤치가 이미지에 없음, (D) 엘리베이터가 사진에 없음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "The nurse is stepping down the stairs.",
      B: "The nurse is going up the stairs.",
      C: "The nurse is standing by the railing.",
      D: "The nurse is holding a clipboard.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 간호사가 계단을 올라가고 있음\n" +
      "오답 설명: (A) 계단을 내려가지 않음, (C) 난간 옆에 서있지 않음, (D) 클립보드를 들고 있지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "The doctor is walking up the stairs.",
      B: "The professionals are descending the stairs.",
      C: "The nurse is pushing a wheelchair.",
      D: "The doctor is holding the side rail.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 의료진들이 계단을 내려가고 있음\n" +
      "오답 설명: (A) 계단을 올라가지 않음, (C) 휠체어를 밀고 있지 않음, (D) 난간을 잡고는건 간호사",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The patient is using crutches.",
      B: "The woman is sitting on a wheelchair.",
      C: "The nurse is writing on a clipboard.",
      D: "The patient is lying on a hospital bed.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 환자가 목발을 사용하고 있음\n" +
      "오답 설명: (B) 휠체어에 앉아있지 않음, (C) 간호사가 클립보드에 쓰고 있지 않음, (D) 병원 침대에 누워있지 않음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "Someone is sitting at a desk.",
      B: "A person is holding a stethoscope.",
      C: "A patient is being examined.",
      D: "Two people are walking side by side.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 두 사람이 나란히 걸어가고 있음\n" +
      "오답 설명: (A) 책상에 앉아있는 사람이 없음, (B) 청진기를 들고 있는 사람이 없음, (C) 환자를 진찰하는 장면이 아님",
  },
  {
    questionNumber: 15,
    choices: {
      A: "A patient is lying on a hospital bed.",
      B: "Two people are sitting on a bench.",
      C: "A man is pushing a hospital bed.",
      D: "Someone is cleaning the hallway.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 병원 침대를 밀고 있음\n" +
      "오답 설명: (A) 환자가 휠체어에 앉아 있음, (B) 벤치가 이미지에 없음, (D) 복도를 청소하는 사람이 없음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The woman is holding a stethoscope.",
      B: "The woman is putting on gloves.",
      C: "The woman is writing on a clipboard.",
      D: "The woman is taking off her uniform.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 장갑을 끼고 있음\n" +
      "오답 설명: (A) 청진기가 보이지 않음, (C) 클립보드가 이미지에 없음, (D) 유니폼을 벗고 있지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The doctor is examining the patient.",
      B: "The patient is adjusting her blanket.",
      C: "The nurse is standing by the window.",
      D: "The two people are facing each other.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 두 사람이 서로 마주보고 있음\n" +
      "오답 설명: (A) 의사가 환자의 손을 잡고 마주보고 있지 진찰 중은 아님, (B) 환자가 담요를 만지고 있지 않음, (C) 간호사가 이미지에 없음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "A patient is lying on a hospital bed.",
      B: "Some people are walking down the hallway.",
      C: "A doctor is using a stethoscope.",
      D: "Some people are standing across from each other.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 사람들이 서로 마주보고 서있음\n" +
      "오답 설명: (A) 병원 침대에 누워있는 환자가 없음, (B) 복도를 걸어가는 사람들이 없음, (C) 의사가 청진기를 사용하고 있지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "A veterinarian is examining a dog.",
      B: "The dog is playing outside.",
      C: "The veterinarian is writing on a clipboard.",
      D: "A cat is sitting on the table.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 수의사가 개를 진찰하고 있음\n" +
      "오답 설명: (B) 개가 밖에서 놀고 있지 않음, (C) 수의사가 클립보드에 쓰고 있지 않음, (D) 테이블 위에 고양이가 없음",
  },
];
